import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete } from '@material-ui/lab';
import {
  getStoresAPI,
} from 'api';
import { TextField } from '@material-ui/core';


const CustomStoresAutocomplete = ({setUsersStoreUrl}) => {
  const dispatch = useDispatch();

  const [searchValue, setSearchValue] = useState('');
  const { stores } = useSelector((state) => state.admin);

  const apiUrls = stores?.map((store) => store.apiUrl || 'No stores');

  useEffect(() => {
    if (searchValue) {
      const params = new URLSearchParams({
        apiUrl: searchValue,
        page: '1',
        limit: '10',
      }).toString();

      getStoresAPI({dispatch, params});
    }
  }, [
    searchValue
  ]);

  return (
    <Autocomplete
      freeSolo
      disableClearable
      options={apiUrls}
      getOptionLabel={(option) => option}
      onInputChange={(e, value) => {
        setSearchValue(value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          onBlur={(e) => setUsersStoreUrl(e.target.value)}
          label={
            <div className="flex items-center">
              Store URL
            </div>
          }
          InputProps={{ ...params.InputProps, type: 'search' }}
        />
      )}
    />
  );
};

export default CustomStoresAutocomplete;
